// js/sections/ProductRecommendations.js

class ProductRecommendationsSection extends HTMLElement {
  constructor() {
    super();
    this.settings = JSON.parse(this.getAttribute("data-settings")) || {};
    this.observer = null;
    this.abortController = null;
  }

  connectedCallback() {
    // Instance-scoped AbortController: aborted in disconnectedCallback so a
    // mid-flight fetch cannot write to a detached DOM node.
    this.abortController = new AbortController();

    // Lazy loading cu IntersectionObserver pentru performanță
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
      rootMargin: '100% 0px',
      threshold: 0
    });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    // Cleanup observer
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    // Cancel in-flight recommendations fetch (skill: cos-theme/fetch-abort-on-disconnect).
    if (this.abortController) {
      this.abortController.abort();
      this.abortController = null;
    }
  }
  handleIntersection(entries) {
    if (!entries[0].isIntersecting) return;

    // Stop observing after first intersection
    this.observer.unobserve(this);

    // Check if we already have products from Liquid
    const existingProducts = this.querySelector('.product-item');
    if (existingProducts) {
      return;
    }

    // Load recommendations when section becomes visible
    this._loadRecommendations();
  }

  _attachListeners() {
    // Quick view functionality is handled by cos-product-item component
  }
  /**
   * On Safari 11.1 and lower, the browser incorrectly calculate the height of flex and grid items due to a bug
   * on how padding percentage is calculated (that we use for allocating image space). This is solved in Safari 11.1 and higher.
   *
   * For those browsers, we fix that in JavaScript by setting the height directly for each aspect ratio image
   *
   * @private
   */

  /**
   * Load product recommendations via Shopify's recommendations API
   * recommendations.products nu este disponibil în toate secțiunile, deci trebuie fetch
   */
  _loadRecommendations() {
    const productId = this.settings.productId;
    const sectionId = this.getAttribute('data-section-id');
    const intent = this.settings.intent === 'complementary' ? 'complementary' : 'related';

    if (!productId || !sectionId) {
      console.warn('Product ID or Section ID not available for recommendations');
      return;
    }

    // Adaugă clasa loading generic
    this.classList.add('loading');

    // Verifică dacă window.Shopify.routes.root există
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const url = `${root}recommendations/products?product_id=${productId}&limit=12&intent=${intent}&section_id=${sectionId}`;

    // Cancel previous in-flight load (skill: cos-theme/fetch-abort-on-disconnect).
    if (this.abortController) {
      this.abortController.abort();
    }
    this.abortController = new AbortController();
    const currentController = this.abortController;

    fetch(url, { signal: currentController.signal })
      .then(response => {
        if (currentController.signal.aborted) return null;
        // Non-2xx here is almost always a crawler or Shopify throttling the endpoint
        // (401 for meta-externalads, 404 on preview URLs, 429, 503) — never a real user
        // fault. Degrade silently like the "no products" path instead of reporting.
        if (!response.ok) {
          console.warn(`Recommendations unavailable: ${response.status}`);
          this.hidden = true;
          this.style.display = 'none';
          return null;
        }
        return response.text();
      })
      .then(text => {
        if (text === null || currentController.signal.aborted) return;
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        const hasProducts = recommendations && recommendations.querySelector('.product-item');

        if (!hasProducts) {
          // No recommendations available → hide entire section (heading + slider)
          this.hidden = true;
          this.style.display = 'none';
          return;
        }

        const currentRecommendations = this.querySelector('.product-recommendations');
        if (currentRecommendations) {
          currentRecommendations.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(error => {
        // AbortError on unmount is expected, not a failure.
        if (error.name === 'AbortError') return;
        console.error('Error loading product recommendations:', error);
        if (window.__queueError) window.__queueError(error);
      })
      .finally(() => {
        // Skip class toggle if we were aborted — the element is gone.
        if (currentController.signal.aborted) return;
        // Elimină clasa loading când se termină (succes sau eroare)
        this.classList.remove('loading');
      });
  }


}
if (!window.customElements.get("cos-product-recommendations")) window.customElements.define("cos-product-recommendations", ProductRecommendationsSection);
